import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import CustomNavbar from "../components/common/CustomNavbar";

const TermsConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <CustomNavbar />
      <Container>
        <div className="py-5 ff">
          <h2 className="fw-bold" style={{ color: "#FF6900" }}>
            Terms & Conditions
          </h2>

          <h4 className="mt-5">INTRODUCTION</h4>
          <p>
            This website is operated by Mahna Astrology Private Limited. VedGuru
            is a brand operated by Mahna Astrology Private Limited, offering
            astrology services and products. The terms “we,” “us,” “our,” and
            “VedGuru” refer to Mahna Astrology Private Limited throughout this
            site. By accessing this website, utilizing our astrology services,
            or purchasing products including but not limited to, gems,
            decorative items, jewellery (both artificial and real), holy water,
            synthetic essential oil, natural essential oil, perfume and perfume
            products, yantra, god idols , astrological charts, books, clothing,
            merchandise, and general ayurvedic, religious, and astrology
            products, you agree to abide by these Terms & Conditions (“Terms”),
            which include all policies and notices referenced here or linked on
            the site. These Terms apply to all users, including casual visitors,
            customers, astrologers, vendors, and content contributors.
            {/* [Full paragraph content continues here] */}
          </p>
          <p>
            We urge you to review these Terms carefully before engaging with our
            website. Your use of any part of this site signifies your acceptance
            of these Terms. If you disagree with any portion of this agreement,
            you must refrain from accessing the site or its services. Any new
            features, tools, or offerings introduced will also fall under these
            Terms. The latest version of these Terms is always available on this
            page, and we may update or amend them at our discretion by posting
            changes here. It’s your responsibility to check for updates
            periodically, and continued use after changes implies your consent
            to them. Our platform enables us to deliver astrology services and
            sell products, including but not limited to, astrological
            consultations, spiritual products, and related merchandise. By
            accessing this website, booking astrology services, or purchasing
            products, you agree to abide by these Terms & Conditions.
            {/* [Full paragraph content continues here] */}
          </p>

          <h4 className="mt-5">1. ELIGIBILITY AND USAGE RULES</h4>
          <p>
            By accepting these Terms, you confirm that you are of legal age of
            18+ years. By using our services, you confirm that you meet these
            age requirements. You may not use our services or products for
            illegal purposes or in violation of any applicable laws, including
            intellectual property regulations. Introducing viruses, malware, or
            harmful code is strictly prohibited. Any violation of these Terms
            will lead to immediate suspension of your access to our services.
          </p>

          <h4 className="mt-5">2. GENERAL PROVISIONS</h4>
          <p>
            We may deny service to any individual at any time for any reason.
            Your data (excluding payment details) may be transmitted unencrypted
            across networks and adapted to technical requirements, while payment
            information remains encrypted. You are prohibited from copying,
            reproducing, selling, or exploiting any part of our services or
            website content without our explicit written approval. Section
            headings are for convenience and do not alter the meaning of these
            Terms. We are not liable for any indirect, incidental, or
            consequential damages arising from your use of our website or
            services. While we take reasonable precautions to protect your data,
            we cannot guarantee complete security against unauthorized access.
          </p>

          <h4 className="mt-5">3. INFORMATION RELIABILITY</h4>
          <p>
            Information on this site, including astrological insights and
            product details, may not always be precise, complete, or up-to-date.
            It is intended for general guidance, and spiritual purposes only,
            not as a definitive basis for decisions. Relying on this information
            is at your own risk, and we recommend consulting more authoritative
            sources where necessary. Historical data may be present but is not
            current. We may alter site content at any time without obligation to
            update it, and you are responsible for tracking such changes.
            Astrological insights provided on this website are for general
            guidance and spiritual reflection only. Your reliance on such
            information is at your own risk.
          </p>

          <h4 className="mt-5">4. SERVICE AND PRICE ADJUSTMENTS</h4>
          <p>
            Prices for products (e.g., gems, decorative items, jewellery (both
            artificial and real), holy water, synthetic essential oil, natural
            essential oil, perfume and perfume products, yantra, god idols ,
            astrological charts, books, clothing, merchandise, and general
            ayurvedic, religious, and astrology products) and astrology services
            may change without prior notice. We reserve the right to modify,
            suspend, or discontinue any service or product offering at our
            discretion, without liability to you or any third party for such
            actions.
          </p>

          <h4 className="mt-5">5. PRODUCTS AND ASTROLOGY OFFERINGS</h4>
          <p>
            Some products and services, such as personalized astrology readings
            or exclusive gemstones, may only be available online and are subject
            to our Refund Policy:{" "}
            <span className=" text-primary">
              &nbsp; https://thevedguru.com/refund-policy &nbsp;
            </span>
            . Astrology consultations are facilitated by independent astrologers
            partnered with us, and while we aim for quality, results are not
            guaranteed due to their subjective nature.
          </p>
          <p>
            We strive to present product images and descriptions accurately but
            cannot ensure your device displays them precisely. We may restrict
            sales or quantities to specific regions or individuals and
            discontinue offerings at our discretion. Product and service
            descriptions may change without notice, and offers are void where
            prohibited by law. We do not promise that products or services will
            meet your expectations, as astrology is for spiritual enrichment,
            not professional advice. We strive to ensure the authenticity of
            products, especially gemstones and religious idols. However, we do
            not guarantee specific certifications or endorsements for all items.
            For detailed information on product origin or certifications, please
            contact us directly.
          </p>

          <h4 className="mt-5">6. BILLING AND ACCOUNT DETAILS</h4>
          <p>
            We may decline or adjust any order or service request at our
            discretion, including limiting quantities per person or household.
            Restrictions may apply to orders using the same account or payment
            method. If we alter or cancel an order, we’ll attempt to notify you
            via the contact details provided. You must supply accurate and
            current billing and account information and update it promptly as
            needed. See our Refund Policy for more:{" "}
            <span className=" text-primary">
              https://thevedguru.com/refund-policy
            </span>
            .
          </p>

          <h4 className="mt-5">7. THIRD-PARTY TOOLS</h4>
          <p>
            We may offer access to third-party tools (e.g., zodiac calculators)
            without oversight or endorsement. These are provided “as is,” and
            your use is at your own risk. We bear no responsibility for issues
            arising from these tools, and you should review the terms of the
            third-party providers. Third-party tools provided on our website are
            accessible at your own risk. We are not responsible for the privacy
            practices, security measures, or data collection policies of these
            third-party providers.
          </p>

          <h4 className="mt-5">8. EXTERNAL LINKS</h4>
          <p>
            Our site may feature content or links to third-party websites. We do
            not control or verify these external resources and are not liable
            for their accuracy, content, or any resulting damages. Review
            third-party policies before engaging with them, and direct any
            concerns to those providers. Links to external websites are provided
            for your convenience. We do not endorse, control, or assume
            responsibility for the content, policies, or practices of these
            external sites
          </p>

          <h4 className="mt-5">9. USER INPUT AND SUBMISSIONS</h4>
          <p>
            If you submit feedback, reviews, or ideas (collectively
            “submissions”), whether requested or unsolicited, we may use, edit,
            or share them freely without obligation to compensate you or keep
            them confidential. We may monitor or remove submissions we deem
            inappropriate or infringing, but we are not required to do so. Your
            submissions must not violate third-party rights or contain harmful
            or illegal content, and you are solely accountable for their
            accuracy. By submitting feedback, reviews, or content, you grant us
            a non-exclusive, royalty-free, perpetual, and irrevocable right to
            use, modify, and share your submissions for any purpose, including
            marketing and promotional activities.
          </p>

          <h4 className="mt-5">10. PRIVACY</h4>
          <p>
            We are committed to protecting your personal information. Our
            practices comply with applicable data protection laws, including the
            General Data Protection Regulation (GDPR) where relevant. For
            detailed information, please refer to our Privacy Policy:
            <span className=" text-primary">
              &nbsp; https://thevedguru.com/privacy-policy
            </span>
            .
          </p>
          <p>
            This website uses cookies to enhance your browsing experience. By
            continuing to use the site, you consent to our use of cookies
          </p>

          <h4 className="mt-5">11. ERRORS AND CORRECTIONS</h4>
          <p>
            Our site may occasionally contain errors in pricing, product
            details, or availability. We may correct these or cancel affected
            orders without prior notice, even after submission, and are not
            obligated to update information unless legally required.
          </p>

          <h4 className="mt-5">12. RESTRICTED ACTIONS</h4>
          <p>
            You may not use our site: (a) for illegal activities; (b) to
            encourage unlawful behavior; (c) to breach laws or intellectual
            property rights; (d) to harass or discriminate; (e) to provide false
            information; (f) to spread malware; (g) to collect others’ data; (h)
            to spam or scrape; or (i) to disrupt security features. Violations
            may result in service termination.
          </p>

          <h4 className="mt-5">13. WARRANTY DISCLAIMER AND LIABILITY LIMITS</h4>
          <p>
            We do not assure uninterrupted, secure, or error-free service.
            Astrology readings are for spiritual purposes, and their accuracy is
            not guaranteed. Your use of our services and products is at your own
            risk, provided “as is” without warranties of merchantability or
            fitness for a specific purpose. VedGuru, its affiliates,
            astrologers, and partners are not liable for any damages—direct,
            indirect, or consequential—arising from your use, limited to the
            extent allowed by law. We shall not be held liable for any failure
            or delay in performance due to events beyond our reasonable control,
            including but not limited to natural disasters, pandemics,
            government actions, or technical failures.
          </p>

          <h4 className="mt-5">14. INDEMNITY</h4>
          <p>
            You agree to protect VedGuru, its affiliates, astrologers, and staff
            from claims, including legal fees, arising from your breach
            Ascertain violations of these Terms or third-party rights.
          </p>

          <h4 className="mt-5">15. SEVERABILITY</h4>
          <p>
            If any part of these Terms is invalid, the remaining provisions
            remain enforceable to the fullest extent permitted by law.
          </p>

          <h4 className="mt-5">16. TERMINATION</h4>
          <p>
            We reserve the right to suspend or terminate your account if you
            violate these Terms. You may also request account termination by
            contacting us at support@vedguru.com. Termination does not affect
            any obligations incurred prior to the date of termination.
          </p>

          <h4 className="mt-5">17. SHIPPING AND DELIVERY</h4>
          <p>
            We aim to ship products within [X] business days of order
            confirmation. Delivery times may vary due to location, carrier
            delays, or customs processes. We are not liable for delays beyond
            our control. Shipping costs and tracking details will be provided at
            checkout. You are responsible for providing accurate delivery
            information; additional fees may apply for re-delivery due to
            errors.
          </p>

          <h4 className="mt-5">18. INTELLECTUAL PROPERTY</h4>
          <p>
            All content on this website, including text, images, logos, and
            astrological charts, is the property of Mahna Astrology Private
            Limited or its licensors and is protected by copyright and trademark
            laws. You may not reproduce, distribute, or use such content without
            our prior written consent, except for personal, non-commercial use.
          </p>

          <h4 className="mt-5">19. COMPLETE AGREEMENT</h4>
          <p>
            These Terms, with linked policies, form the full agreement between
            us, overriding prior understandings.
          </p>

          <h4 className="mt-5">20. APPLICABLE LAW</h4>
          <p>These Terms are governed by the laws of India.</p>

          <h4 className="mt-5">21. ARBITRATION</h4>
          <p>
            Any disputes arising out of or related to these Terms will be
            resolved through binding arbitration in Delhi, India, under the
            prevailing laws. The proceedings will be conducted in English, and
            the arbitrator’s decision will be final and enforceable.
          </p>

          <h4 className="mt-5">22. TERM UPDATES</h4>
          <p>
            We may revise these Terms by updating this page. Continued use
            post-changes signifies acceptance.
          </p>

          <h4 className="mt-5">23. ASTROLOGY SERVICE TERMS</h4>
          <ul>
            <li className="mt-4 list">
              <strong>Purpose:</strong> Astrology services are for spiritual and
              personal reflection, not professional advice (e.g., medical,
              legal).
            </li>
            <li className="mt-3 list">
              <strong>Astrologer Autonomy:</strong> Astrologers operate
              independently, and their views do not necessarily represent
              VedGuru.
            </li>
            <li className="mt-3 list">
              <strong>No Outcome Guarantees:</strong> Refunds for
              dissatisfaction with predictions are subject to our Refund Policy.
            </li>
            <li className="mt-3 list">
              <strong>Confidentiality Clause:</strong> We respect the privacy of
              your astrological consultations. While we take reasonable measures
              to protect your data, we are not liable for data breaches caused
              by external threats beyond our control.
            </li>
          </ul>

          <h4 className="mt-5">24. CONTACT</h4>
          <p>
            Reach us at{" "}
            <a className=" text-primary" href="mailto:support@vedguru.com">
              support@vedguru.com
            </a>
          </p>
        </div>
      </Container>
    </div>
  );
};

export default TermsConditions;
